
/* CLARIA Pro Norge : galleri, equalizer, levering, Shopify-handlekurv + tillegg */
(function(){
  var CFG = window.CLARIA_PRO || {variants:{}};
  var V = CFG.variants;
  var $ = function(s, r){ return (r||document).querySelector(s); };
  var $$ = function(s, r){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); };
  var byId = function(id){ return document.getElementById(id); };

  /* galerie */
  window.cpGal = function(btn, src){ byId('galMain').src = src; $$('.cp-gal-thumbs button').forEach(function(b){ b.classList.remove('cp-on'); }); btn.classList.add('cp-on'); };

  /* égaliseur */
  var EQ = {
    basic:  {h:[62,62,62,62,62,62,62,62,62,62,62,62,62,62,62,62], v:[], note:"Én innstilling: alt går opp samtidig, støyen like mye som stemmene."},
    claria: {h:[18,16,15,14,22,40,58,70,82,90,96,92,84,74,60,48], v:[5,6,7,8,9,10,11,12,13,14,15], note:"16 bånd som justeres hver for seg: de dype støytonene holdes nede, mellomtonene og de lyse tonene i stemmene forsterkes."}
  };
  function drawEq(mode){
    var box = byId('eqBars'); if(!box) return;
    if(!box.children.length){ for(var i=0;i<16;i++){ var s=document.createElement('span'); s.style.height='4%'; box.appendChild(s);} }
    var d = EQ[mode];
    Array.prototype.forEach.call(box.children, function(s,i){ s.style.height = d.h[i]+'%'; s.classList.toggle('cp-v', d.v.indexOf(i) >= 0); });
    byId('eqNote').textContent = d.note;
  }
  window.cpEq = function(btn, mode){ $$('.cp-eq-tabs button').forEach(function(b){ b.classList.remove('cp-on'); }); btn.classList.add('cp-on'); drawEq(mode); };


  /* liens internes : défilement fluide vers une section, sans changer l'URL (ligne d'avis -> #avis) */
  function headerOffset(){ var off = 0; $$('header, .section-header, .shopify-section-header, .shopify-section-group-header-group, .header').forEach(function(e){ var cs = getComputedStyle(e); if(cs.position === 'fixed' || cs.position === 'sticky') off = Math.max(off, e.getBoundingClientRect().height); }); return (off || 0) + 16; }
  window.cpScrollTo = function(id){ var t = byId(id); if(!t) return; var top = t.getBoundingClientRect().top + window.pageYOffset - headerOffset(); window.scrollTo({top: top, behavior: 'smooth'}); };
  document.addEventListener('click', function(e){ var a = e.target.closest && e.target.closest('[data-scroll]'); if(!a) return; e.preventDefault(); cpScrollTo(a.getAttribute('data-scroll')); });

  /* forventet levering : 4 til 8 virkedager */
  function deliv(){
    var el = byId('delivDate'); if(!el) return;
    var biz = function(n){ var x = new Date(); while(n>0){ x.setDate(x.getDate()+1); var wd=x.getDay(); if(wd!==0 && wd!==6) n--; } return x; };
    var f = function(d){ return d.toLocaleDateString('nb-NO',{weekday:'short',day:'numeric',month:'short'}); };
    el.textContent = 'mellom ' + f(biz(4)) + ' og ' + f(biz(8));
  }

  /* ---------------- panier Shopify ---------------- */
  var lot = 1, cart = null, busy = false;
  var SUB = {main:'Paret · ladeetui · 10 ørepropper', lot:'2 par · til dere to', acc:'Egen hørselsveileder · 2 samtaler', ser:'Brudd, tap, ørepropper for livet', liv:'Nytt apparat straks ved tap, tyveri eller skade'};
  function vid(k){ return (V[k] && V[k].id) ? Number(V[k].id) : 0; }
  function keyOf(variantId){ for(var k in V){ if(Number(V[k].id) === variantId) return k; } return null; }
  function item(k){ if(!cart) return null; var id = vid(k); for(var i=0;i<cart.items.length;i++){ if(cart.items[i].variant_id === id) return cart.items[i]; } return null; }
  function lineKey(variantId){ if(!cart) return null; for(var i=0;i<cart.items.length;i++){ if(cart.items[i].variant_id === variantId) return cart.items[i].key; } return null; }
  function eur(c){ var n = Math.round(c/100); return n.toLocaleString('nb-NO',{maximumFractionDigits:0}).replace(/\s/g,'\u00a0') + '\u00a0kr'; }
  function post(path, body){
    return fetch(path, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify(body)})
      .then(function(r){ if(!r.ok){ return r.json().then(function(j){ throw new Error(j.description || j.message || 'Feil i handlekurven'); }); } return r.json(); });
  }
  var ROOTURL = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function refresh(){ return fetch(ROOTURL + 'cart.js', {headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); }).then(function(c){ cart = c; render(); return c; }); }
  function add(k){ if(!vid(k)) return Promise.resolve(); return post(ROOTURL + 'cart/add.js', {items:[{id: vid(k), quantity: 1}]}); }
  function setQty(variantId, q){ var k = lineKey(variantId); if(!k) return Promise.resolve(); return post(ROOTURL + 'cart/change.js', {id: k, quantity: q}); }
  var watchdog = null;
  function run(fn){ if(busy) return; busy = true; clearTimeout(watchdog); watchdog = setTimeout(function(){ busy = false; }, 12000);
    var b = byId('checkoutBtn'); if(b) b.style.opacity = .6;
    (cart ? Promise.resolve(cart) : refresh()).then(fn).then(refresh).catch(function(e){ alert(e.message || 'Noe gikk galt, prøv igjen.'); return refresh(); }).then(function(){ busy = false; clearTimeout(watchdog); }); }

  window.cpLot = function(n){ if(n === 2 && !vid('lot')) n = 1; lot = n; $$('.cp-lot').forEach(function(l){ l.classList.toggle('cp-on', Number(l.querySelector('input').value) === n); });
    var bp = byId('btnPrice'); if(bp) bp.textContent = '· ' + eur(n === 2 && V.lot ? V.lot.price : V.main.price); };
  var ROOT = byId('claria-pro');
  window.cpOpenCart = function(){ byId('cp-cart').classList.add('cp-on'); byId('cp-overlay').classList.add('cp-on'); if(ROOT) ROOT.classList.add('cp-drawer-open'); document.documentElement.style.overflow = 'hidden'; if(!cart) refresh(); };
  window.cpCloseCart = function(){ byId('cp-cart').classList.remove('cp-on'); byId('cp-overlay').classList.remove('cp-on'); if(ROOT) ROOT.classList.remove('cp-drawer-open'); document.documentElement.style.overflow = ''; };

  /* Tiroir natif du thème (Glozin) : on le referme dès qu'il tente de s'ouvrir et on ouvre le nôtre à la place. */
  function killNativeCart(){
    var html = document.documentElement, mw = byId('minicart_wrapper');
    if(!html.classList.contains('open-minicart') && !(mw && mw.classList.contains('open'))) return false;
    html.classList.remove('open-minicart', 'open-drawer'); html.style.removeProperty('padding-right');
    if(mw){ mw.classList.remove('open'); var w = mw.querySelector('.minicart__wrapper'); if(w) w.classList.remove('open'); }
    return true;
  }
  function watchNative(){
    if(!('MutationObserver' in window)) return;
    var html = document.documentElement, mw = byId('minicart_wrapper');
    var mo = new MutationObserver(function(){ if(killNativeCart() && !byId('cp-cart').classList.contains('cp-on')) cpOpenCart(); });
    mo.observe(html, {attributes:true, attributeFilter:['class']});
    if(mw) mo.observe(mw, {attributes:true, attributeFilter:['class']});
    /* icône panier du header -> notre tiroir */
    document.addEventListener('click', function(e){
      var a = e.target.closest && e.target.closest('#cart-icon-bubble, .minicart__action');
      if(!a || a.closest('#claria-pro')) return;
      e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation(); cpOpenCart();
    }, true);
  }

  /* --- Tiroir natif Glozin : neutralisation a la source (21/09/2026) ---
     Le CSS l'empeche deja d'etre peint. Ici on empeche le theme de croire
     qu'il l'a ouvert : sinon il laisse overflow:hidden sur <html>. */
  function neutraliseNatif(){
    function redirige(el){
      if(!el || el.__cpPatched) return;
      el.__cpPatched = true;
      ['open','show','renderContents'].forEach(function(m){
        if(typeof el[m] === 'function'){
          var orig = el[m].bind(el);
          el[m] = function(){
            try{ if(m === 'renderContents') orig.apply(null, arguments); }catch(e){}
            killNativeCart();
            if(!byId('cp-cart').classList.contains('cp-on')) cpOpenCart();
            return undefined;
          };
        }
      });
    }
    redirige(byId('minicart_wrapper'));
    try{
      var CN = window.customElements && customElements.get('cart-notification');
      if(CN && CN.prototype && !CN.prototype.__cpPatched){
        CN.prototype.__cpPatched = true;
        ['open','show'].forEach(function(m){
          if(typeof CN.prototype[m] === 'function'){
            CN.prototype[m] = function(){
              killNativeCart();
              if(!byId('cp-cart').classList.contains('cp-on')) cpOpenCart();
            };
          }
        });
      }
    }catch(e){}
  }
  neutraliseNatif();
  document.addEventListener('DOMContentLoaded', neutraliseNatif);

  /* 17/10 : affichage immediat du tiroir (ligne optimiste), la vraie reponse Shopify remplace ensuite */
  function optimistic(){ try{ if(!cart || item('main') || item('lot') || !V.main || !V.main.id) return;
    var c = JSON.parse(JSON.stringify(cart)); var it = {variant_id: V.main.id, quantity: 1, product_title: V.main.title || '', image: V.main.image || '', final_line_price: V.main.price, key: 'tmp'};
    c.items = [it].concat(c.items || []); c.item_count = (c.item_count || 0) + 1; c.total_price = (c.total_price || 0) + V.main.price;
    var real = cart; cart = c; render(); cart = real; }catch(e){} }
  window.cpAdd = function(){ cpOpenCart(); optimistic(); run(function(){ return Promise.resolve().then(function(){
      if(item('main') || item('lot')) return; return add(lot === 2 && vid('lot') ? 'lot' : 'main'); }); }); };
  window.cpUp = function(k){ if(!vid(k === 'duo' ? 'lot' : k)) return; run(function(){ return Promise.resolve().then(function(){
      if(k === 'duo'){ /* bascule 1 paire <-> lot de 2 */
        if(item('lot')) return setQty(vid('lot'), 0).then(function(){ return add('main'); });
        var p = item('main') ? setQty(vid('main'), 0) : Promise.resolve(); return p.then(function(){ return add('lot'); });
      }
      if(item(k)) return setQty(vid(k), 0);
      var p2 = (item('main') || item('lot')) ? Promise.resolve() : add('main');
      return p2.then(function(){ return add(k); });
    }); }); };
  window.cpQty = function(variantId, d){ var it = null; cart.items.forEach(function(i){ if(i.variant_id === variantId) it = i; }); if(!it) return;
    run(function(){ return setQty(variantId, Math.max(0, it.quantity + d)).then(refresh).then(function(){
      /* plus d'appareil : on retire aussi la protection et les options */
      if(!item('main') && !item('lot')){ var p = Promise.resolve(); ['liv','acc','ser'].forEach(function(k){ if(vid(k) && item(k)) p = p.then(function(){ return setQty(vid(k), 0); }); }); return p; } }); }); };
  window.cpCheckout = function(){ if(cart && cart.item_count) window.location.href = ROOTURL + 'checkout'; return false; };

  function render(){
    if(!cart) return;
    var lines = byId('cartLines'); lines.innerHTML = '';
    var n = 0;
    cart.items.forEach(function(it){
      var k = keyOf(it.variant_id);
      if(k !== 'liv') n += it.quantity;
      if(k === 'liv') return;
      var el = document.createElement('div'); el.className = 'cp-line';
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, '_200x200$1$2') : '';
      el.innerHTML = '<img src="' + img + '" alt="">' +
        '<div><div class="cp-line-t">' + it.product_title + '</div><div class="cp-line-s">' + (SUB[k] || (it.variant_title || '')) + '</div>' +
        '<div class="cp-line-b"><div class="cp-qty"><button type="button" onclick="cpQty(' + it.variant_id + ',-1)" aria-label="Færre">−</button><span>' + it.quantity + '</span><button type="button" onclick="cpQty(' + it.variant_id + ',1)" aria-label="Flere">+</button></div>' +
        '<div class="cp-line-p">' + eur(it.final_line_price) + '</div></div></div>';
      lines.appendChild(el);
    });
    byId('cartEmpty').style.display = n ? 'none' : 'block';
    byId('cartCount2').textContent = '(' + n + ')';
    byId('grandTotal').textContent = eur(cart.total_price);
    var x3 = byId('x3Amt'); if(x3) x3.textContent = eur(Math.round(cart.total_price / 3));
    var lv = byId('upLiv'); if(lv){ var on = !!item('liv'); lv.classList.toggle('cp-on', on); var bx = lv.querySelector('.cp-ck'); if(bx) bx.textContent = on ? '✓' : ''; }
    var lp = byId('livPrice'); if(lp && V.liv) lp.textContent = eur(V.liv.price);
    var co = byId('checkoutBtn'); co.style.opacity = n ? 1 : .5; co.style.pointerEvents = n ? 'auto' : 'none';
    /* compteur du thème (meilleur effort) */
    $$('.cart-count-bubble span[aria-hidden], .cart-count, [data-cart-count], .header__cart-count, .cart-count-number').forEach(function(e){ e.textContent = n; });
    var bub = byId('cart-icon-bubble'); if(bub){ $$('*', bub).forEach(function(e){ if(!e.children.length && /^\d+$/.test(e.textContent.trim())) e.textContent = n; }); }
  }
  /* frise du panier : dates courtes */
  function cartDates(){
    var biz = function(k){ var x = new Date(); while(k > 0){ x.setDate(x.getDate() + 1); var w = x.getDay(); if(w && w !== 6) k--; } return x; };
    var sh = function(d){ return d.toLocaleDateString('nb-NO',{weekday:'short',day:'numeric',month:'short'}); };
    var dm = function(d){ return d.toLocaleDateString('nb-NO',{day:'numeric',month:'short'}); };
    var a = biz(4), b = biz(8), e = new Date(b); e.setDate(e.getDate() + 45);
    var set = function(id, t){ var el = byId(id); if(el) el.textContent = t; };
    set('shipS', sh(biz(1))); set('rangeS', a.getMonth() === b.getMonth() ? a.getDate() + ' – ' + dm(b) : dm(a) + ' – ' + dm(b)); set('endS', dm(e));
  }

  function init(){
    drawEq('basic'); deliv(); cartDates();
    /* vidéo de la bannière : démarrage forcé (muet) pour les navigateurs mobiles qui ignorent autoplay */
    $$('#claria-pro video').forEach(function(v){ v.muted = true; v.setAttribute('muted', ''); var go = function(){ var pr = v.play(); if(pr && pr.catch) pr.catch(function(){}); }; go();
      document.addEventListener('touchstart', go, {once:true, passive:true}); document.addEventListener('scroll', go, {once:true, passive:true}); });
    var eq = $('.cp-eq');
    if(eq && 'IntersectionObserver' in window){ var done = false;
      new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting && !done){ done = true; setTimeout(function(){ var b = $$('.cp-eq-tabs button')[1]; if(b) cpEq(b, 'claria'); }, 900); } }); }, {threshold:.5}).observe(eq); }
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') cpCloseCart(); });
    watchNative();
    refresh().catch(function(){});
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
